var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LocationForm',{attrs:{"post-save-action":_vm.add,"show-buttons":false,"two-column-layout":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }